<template>
    <div>
        <v-skeleton-loader tile v-if="isLoading && !contractDebt" type="table"></v-skeleton-loader>
        <v-data-table
            v-else
            :headers="headers"
            :server-items-length="rowCount"
            :itemStart="itemStart"
            :loading="isLoading"
            :items="contractDebt"
            item-key="contract_number"
            disable-filtering
            loader-height="1"
            disable-sort
            disable-pagination
            show-select
            checkbox-color="#6B7BB2"
            v-model="selectedSync"
            hide-default-footer
            :item-class="itemRowBackground"
            no-data-text="За вами нет закрепленных объектов"
        >
            <template v-slot:header.data-table-select="{ on, props }">
                <th>
                    <v-simple-checkbox v-ripple v-bind="props" v-on="on" dark />
                </th>
            </template>

            <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
                <th :key="index" v-html="header.text"></th>
            </template>

            <template v-slot:item.data-table-select="{ item }">
                <td style="vertical-align: top">
                    <v-checkbox style="margin:0; padding:0" :value="item" v-model="selectedSync" color="gray" />
                </td>
            </template>

            <template v-slot:item.contract_number="{ item }">
                <td style="vertical-align: top;">
                    <div class="mb-4">
                        <div>{{ item['contract_number'] }}</div>
                        <div>{{ item['contractor_name'] }}</div>
                    </div>
                </td>
            </template>

            <template v-slot:item.address="{ item }">
                <td style="vertical-align: top">
                    <div class="pb-4">
                        {{ item['address_full_name'] }}
                    </div>
                    <div class="pb-4">
                        <div>{{ item['district_name'] }}</div>
                        <div>{{ item['customer_service_center_name'] }}</div>
                    </div>
                    <div class="primaryDark--text" v-for="contact in item.contacts" :key="contact['contr_contact_value']">
                        {{ contact['contr_contact_value'] }}
                    </div>
                </td>
            </template>

            <template v-slot:item.date="{ item }">
                <td style="vertical-align: top">
                    <div>{{ item['contract_open_date'] }}</div>
                    <div>{{ item['contract_end_date'] }}</div>
                </td>
            </template>

            <template v-slot:item.debts="{ item }">
                <td style="vertical-align: top;">
                    <div v-for="debt of item['debts_info']" :key="debt.record_id">
                        <div class="pb-4">
                            <div>
                                {{ debt['sum_debt'] }}
                            </div>
                            <div>
                                {{ debt['suppl_service_group_name'] }}
                            </div>
                        </div>
                        <div v-if="item['debts_info'].length === 1">
                            <div>
                                0.00
                            </div>
                            <div>
                                Пеня
                            </div>
                        </div>
                    </div>
                </td>
            </template>

            <template v-slot:item.pre_trial_notice="{ item }">
                <td style="vertical-align: top;">
                    <div class="pb-4">
                        <div>
                            {{ item['pre_trial_notice']['status_name'] }}
                        </div>
                        <div>
                            {{ item['pre_trial_notice']['status_date'] }}
                        </div>
                        <div>
                            {{ item['pre_trial_notice']['engineer_name'] }}
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <v-btn class="mb-4" color="gray" small outlined @click.stop="showDialog(item.record_id)" rounded>Подробно</v-btn>
                        <v-btn @click.stop="openCreateActDialog(item)" small height="64" width="177" rounded color="gray">
                            <div class=" d-flex">
                                <v-icon color="white">add</v-icon>
                                <div class="white--text text-left">
                                    акт<br />
                                    на подключение /<br />отключение
                                </div>
                            </div>
                        </v-btn>
                    </div>
                </td>
            </template>

            <template v-slot:footer>
                <div class="d-flex justify-end">
                    <div class="pr-8">{{ pagination }}</div>
                    <v-icon :disabled="itemStart === 0" @click="decrement" class="pointer">arrow_back_ios</v-icon>
                    <v-icon :disabled="isLastItem" @click="increment" class="pointer">arrow_forward_ios</v-icon>
                </div>
            </template>
        </v-data-table>
        <ObjectDetailsDialog :record-id="selectedRecordId" v-model="dialog" />
        <ObjectsContractActsTable @chooseObject="chooseObject" v-model="objectDialog" :contract-id="contractId" :contract_number="contract_number" />
        <CreateAct v-model="createActDialog" :is-contract="true" :info-create-model.sync="infoCreate" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';
import ObjectDetailsDialog from '@/components/debts-info/contractsDebt/ObjectDetailsDialog.vue';
import ObjectsContractActsTable from '@/components/acts/ObjectsContractActsTable.vue';
import CreateAct from '@/components/acts/CreateAct.vue';
import ActsService from '@/services/apiRequests/acts.service';

export default {
    name: 'ContractsDebtTable',
    components: { CreateAct, ObjectsContractActsTable, ObjectDetailsDialog },
    computed: {
        ...mapGetters('contracts', ['getRowCount', 'getContractDebt']),
        rowCount() {
            return this.getRowCount;
        },
        contractDebt() {
            return translate(this.getContractDebt, 'full', this.$i18n.locale);
        },
        pagination() {
            return `${this.itemStart + 1}-${this.isLastItem ? this.getRowCount : this.itemEnd} из ${this.getRowCount}`;
        },
        itemEnd() {
            return this.itemStart + this.itemsPerPage;
        },
        isLastItem() {
            return this.itemEnd > this.getRowCount;
        },
        selectedSync: {
            get() {
                return this.selected;
            },
            set(val) {
                this.$emit('update:selected', val);
            }
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            required: true
        },
        itemsPerPage: {
            type: Number,
            required: true
        },
        itemStart: {
            type: Number,
            required: true
        },
        selected: {
            required: true
        }
    },
    data: function() {
        return {
            headers: [
                {
                    text: 'Номер договора',
                    value: 'contract_number'
                },
                { text: 'Адрес<br> Административный район<br> Контакты', value: 'address', class: 'status-column' },
                { text: 'Дата заключения<br> Дата окончания', value: 'date' },
                { text: 'Сведения по задолженности', value: 'debts' },
                { text: 'Досудебное уведомление', value: 'pre_trial_notice' }
            ],
            dialog: false,
            selectedRecordId: null,
            createActDialog: false,
            objectDialog: false,
            contractId: null,
            infoCreate: {}
        };
    },
    methods: {
        showDialog(record_id) {
            this.selectedRecordId = record_id;
            this.dialog = true;
        },
        increment() {
            this.$emit('update:itemStart', this.itemStart + this.itemsPerPage);
        },
        decrement() {
            this.$emit('update:itemStart', this.itemStart - this.itemsPerPage);
        },
        itemRowBackground: function(item) {
            return item['not_paid_notice'] ? 'status-column' : '';
        },
        openCreateActDialog(item) {
            this.contractId = item['record_id'];
            this.contract_number = item['contract_number'];
            this.objectDialog = true;
        },
        async chooseObject(objectId) {
            this.objectContractDilog = false;
            const infoCreate = await ActsService.getInfoCreateContractAct(objectId);
            if (!infoCreate.successfull) return;
            this.infoCreate = translate(infoCreate.data[0], 'full', this.$i18n.locale);
            this.infoCreate['obj_suppl_rid'] = objectId;
            this.infoCreate['serv'] = this.infoCreate['serv'] ?? [];
            this.infoCreate['other_serv'] = this.infoCreate['other_serv'] ?? [];
            this.createActDialog = true;
        }
    }
};
</script>

<style lang="scss">
.status-column {
    background-color: #ffebeb;
}
</style>
